<template>
    <div v-html="apply">{{apply}}</div>
</template>
<script>
export default {
    data() {
        return {
            apply:''
        }
    },
    mounted() {
        if(Object.hasOwnProperty.call(this.$route.query,'success')&&Number(this.$route.query.success) === 1){
            localStorage.setItem('cfda_zfbpay',1);
            if (navigator.userAgent.indexOf('MSIE') > 0) { // close IE
                if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
                    window.opener = null;
                    window.close();
                } else {
                    window.open('', '_top');
                    window.top.close();
                }
            } else { // close chrome;It is effective when it is only one.
            window.opener = null;
            window.open('', '_self');
            window.close();
            }
        }else{
            let form = this.$route.query.htmls;
            console.log('form',form);
            this.apply = form;
            this.$nextTick(() => {
                document.forms[0].submit();
            })
        }
        
    },
}
</script>
